import React, { useState, useContext, useEffect } from "react";
import "./styles.css";
import { Images } from "../../theme";
import { AuthContext } from "../../context/AuthContext";
import { DotsLoader, ImageAvatar } from "../../components";
import { useTranslation } from "react-i18next";

export default function CheckOut({ verificationStatus, loginData, onClose }) {
  const getContextItems = useContext(AuthContext);
  let {
    isLoading,
    verfiy_email,
    confirm_verfiy_email,
    verfiy_identity,
    confirm_verfiy_phone,
    verfiy_phone,
    sendCode,
  } = getContextItems;
  const { t } = useTranslation();

  const [value, setValue] = useState("");
  const [valueError, setValueError] = useState(false);
  const [image, setImage] = useState({
    imageData: "",
    ImageUrl: Images.profileImage,
  });

  function checkValidation() {
    if (verificationStatus == 2 && !value) {
      setValueError(t("Required_Phone_numbr"));
    } else if (verificationStatus == 3 && !image.imageData) {
      alert(t("Image_Required"));
    } else {
      if (verificationStatus == 1) {
        verfiy_email();
      } else if (verificationStatus == 2) {
        verfiy_phone({ phone: value });
      } else if (verificationStatus == 3) {
        let formData = new FormData();
        formData.append("image", image.imageData);
        verfiy_identity(formData, onClose);
      }
    }
  }
  function checkCode() {
    if (!value) {
      setValueError(t("Required_Code"));
    } else {
      if (sendCode == 1) confirm_verfiy_email({ code: value }, onClose);
      else if (sendCode == 2) confirm_verfiy_phone({ code: value }, onClose);
    }
  }

  return (
    <div className="bg">
      <div className="center">
        <div
          className="container"
          style={{
            backgroundImage: `url(${Images.bg_image})`,
            borderRadius: 28,
            backgroundColor: "#E5E5E5",
          }}
        >
          <div className="row" style={{ paddingBottom: 50 }}>
            <div className="d-flex justify-content-center my-3">
              <img className="logo-icon" src={Images.logo_white} alt="image" />
            </div>

            <div className="col-sm-9 col-md-9 col-lg-5 mx-auto">
              <div className="card card-signin my-2 border-0">
                <div className="card-body">
                  <h5 className="card-title text-center heading_title">
                    {sendCode == 1 || sendCode == 2
                      ? t("Code")
                      : verificationStatus == 1
                      ? t("Email")
                      : verificationStatus == 2
                      ? t("Phone_Number")
                      : verificationStatus == 3
                      ? t("Enter_cnic")
                      : null}
                  </h5>
                  {verificationStatus == 3 ? (
                    <form
                      action="javascript:void(0)"
                      className="form-signin mt-4 px-2"
                    >
                      <ImageAvatar
                        imageData={setImage}
                        source={image && image.ImageUrl}
                      />
                      <div className="pt-3" style={{ textAlign: "center" }}>
                        {isLoading ? (
                          <DotsLoader />
                        ) : (
                          <button
                            type="button"
                            disabled={isLoading}
                            className="btn-custom btn-light"
                            style={{
                              width: "100%",
                              borderRadius: 10,
                              height: 50,
                            }}
                            onClick={checkValidation}
                          >
                            {t("Submit")}
                          </button>
                        )}
                      </div>
                    </form>
                  ) : (
                    sendCode == 0 && (
                      <form
                        action="javascript:void(0)"
                        className="form-signin mt-4 px-2"
                      >
                        <div className="form-label-group mb-3">
                          <div>
                            <label>
                              {verificationStatus == 1
                                ? t("Email")
                                : t("Phone_Number")}
                            </label>
                            <input
                              className="input-field"
                              value={
                                verificationStatus == 1
                                  ? loginData?.email
                                  : value
                              }
                              disabled={verificationStatus == 1 ? true : false}
                              type={verificationStatus == 2 ? "number" : "text"}
                              placeholder={
                                verificationStatus == 1
                                  ? t("Email")
                                  : t("Phone_Number")
                              }
                              onChange={(e) => {
                                setValueError(false);
                                setValue(e.target.value);
                              }}
                            />
                          </div>
                          <div className="error_text">{valueError}</div>
                        </div>
                        <div className="pt-3" style={{ textAlign: "center" }}>
                          {isLoading ? (
                            <DotsLoader />
                          ) : (
                            <button
                              type="button"
                              disabled={isLoading}
                              className="btn-custom btn-light"
                              style={{
                                width: "100%",
                                borderRadius: 10,
                                height: 50,
                              }}
                              onClick={checkValidation}
                            >
                              {t("Submit")}
                            </button>
                          )}
                        </div>
                      </form>
                    )
                  )}
                  {sendCode == 0 ? null : (
                    <form
                      action="javascript:void(0)"
                      className="form-signin mt-4 px-2"
                    >
                      <div className="form-label-group mb-3">
                        <div>
                          <label>{t("Code")}</label>
                          <input
                            className="input-field"
                            value={value}
                            type="text"
                            placeholder={t("Code")}
                            onChange={(e) => {
                              setValueError(false);
                              setValue(e.target.value);
                            }}
                          />
                        </div>
                        <div className="error_text">{valueError}</div>
                      </div>
                      <div className="pt-3" style={{ textAlign: "center" }}>
                        {isLoading ? (
                          <DotsLoader />
                        ) : (
                          <button
                            type="button"
                            disabled={isLoading}
                            className="btn-custom btn-light"
                            style={{
                              width: "100%",
                              borderRadius: 10,
                              height: 50,
                            }}
                            onClick={checkCode}
                          >
                            {t("Submit")}
                          </button>
                        )}
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
